module.exports = __webpack_public_path__ + "img/162.961d82b6.png";